import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=20f29194&lang=pug"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=20f29194&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports